import request from '@/libs/request'
import { toast } from '../libs/utils'

// 获取预约列表
export async function queueUpList (params) {
  let data = await request.post('/order/orderCheckOrderInfo/showNurseQueueUpList', params)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({msg: data.message || '获取排队列表异常'})
  }
}
// 上传相关资料
export async function uploadRelevantInformation (params) {
  let data = await request.postFile('/order/orderCheckOrderInfo/uploadCheckOrderInfoAttachmentInfo', params)
  if (data && data.code && data.code.toString() === '200') {
    return true
  } else {
    toast({msg: data.message || '上传相关资料异常'})
  }
}
// 查询患者检查单信息
export async function getCheckItemInfo (params) {
  let data = await request.post('/order/orderCheckOrderInfo/queryCheckOrderInfoAttachmentInfoById', params)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({msg: data.message || '获取患者检查单信息异常'})
  }
}
// 删除相关资料
export async function removeRelevantInfomation (params) {
  let data = await request.post('/order/orderCheckOrderInfo/deleteCheckOrderInfoAttachmentInfoById', params)
  if (data && data.code && data && data.code.toString() === '200') {
    return true
  } else {
    toast({msg: data.message || '删除相关资料异常'})
  }
}